import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwSidebarComponent } from './sidebar.component';

@NgModule({
  imports: [CommonModule],
  exports: [MwSidebarComponent],
  declarations: [MwSidebarComponent],
  providers: [],
})
export class MwSidebarModule {}
